import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Login from './Login';
import Unauthorized from './Unauthorized';
import useValidateAttempt from '../hooks/useValidateAttempt';
import useConfig from '../hooks/useConfig';
import OperatorLogin from './OperatorLogin';

function LoadingSpinner() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900">
      <div
        role="status"
        aria-label="Loading"
        className="w-12 h-12 border-4 border-gray-600 border-t-green-500 rounded-full animate-spin"
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default function OperatorGate() {
  const [searchParams] = useSearchParams();
  const { config, loading: configLoading } = useConfig();
  const operator = searchParams.get('operator');
  const attemptId = searchParams.get('attemptId');
  const validOperators = config?.validOperators || ['bet365', 'paddypower', 'skybet', 'betfair'];

  const { status } = useValidateAttempt(config?.operatorGatewayBaseUrl, operator, attemptId);

  if (configLoading) return <LoadingSpinner />;

  if (!operator || !attemptId || status === 'invalid' || !validOperators.includes(operator.toLowerCase())) {
    return <Unauthorized attemptId={attemptId} />;
  }

  if (status === 'loading' || status === 'idle') {
    return <LoadingSpinner />;
  }

  if (operator.toLowerCase() === 'bet365') {
    return <Login autoStart attemptId={attemptId} />;
  } else {
    return <OperatorLogin autoStart attemptId={attemptId} operator={operator} />;
  }
}
